import { render, staticRenderFns } from "./DefaultMurdoch.vue?vue&type=template&id=6f6c5406&"
import script from "./DefaultMurdoch.vue?vue&type=script&lang=js&"
export * from "./DefaultMurdoch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports